<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <NewField/>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <b-table :items="fields">
          <template slot="name" slot-scope="data">
            <router-link :to="{name: 'EditField', params: { id: data.item.id} }">{{data.item.name}}</router-link>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
import NewField from './Form'
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'AdminFieldsIndex',

  data () {
    return {
    }
  },
  components: {
    NewField
  },

  created () {
    this.loadFields()
  },

  mounted () {
    this.loadFields()
  },

  methods: {
    ...mapActions(['loadFields'])
  },
  computed: {
    ...mapGetters(['fields'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/fields/Index.vue